// extracted by mini-css-extract-plugin
export var assigneeBadge = "_jy-0";
export var assigneeDetails = "_jy-1";
export var assigneeInfo = "_jy-2";
export var dropdownContainer = "_jy-4";
export var dropdownImage = "_jy-5";
export var editAssigneeInfo = "_jy-3";
export var editAssigneeModalContainer = "_jy-6";
export var hidden = "_jy-8";
export var input = "_jy-7";